/**
 * RobinhoodSpace GovOps runtime config (build env + optional /govops-config.json).
 */
export const GOVOPS_DEFAULT_ORG_ID = 'robinhoodspace-demo';
export const GOVOPS_DEFAULT_API_BASE = 'https://www.sdpanthers.com/api/govops';

export function getGovOpsOrgId() {
  if (typeof window !== 'undefined' && window.__GOVOPS_ORG_ID__) {
    return String(window.__GOVOPS_ORG_ID__).trim();
  }
  const fromEnv = process.env.REACT_APP_GOVOPS_ORG_ID;
  if (fromEnv && String(fromEnv).trim()) return String(fromEnv).trim();
  return GOVOPS_DEFAULT_ORG_ID;
}

export function orgQueryParams() {
  const orgId = getGovOpsOrgId();
  return orgId ? { orgId } : {};
}
